import React, { useState, useContext } from "react";
import LoadingSuccessErrorAlert from "../Rules/Components/LoadingSuccessErrorAlert";
import { toast } from "react-toastify";
import Utils from "../../../Common/Utils";
import GMSFillButton from "../../Common/components/GMSFillButton";
import Label from "../../Common/components/Label";
import { downloadPDW } from "api/Pdw";
import { checkJobStatus } from "api/Job";
import { AppContext } from "../../../Context/AppContext";

const PdwDownload = ({ categoryTypeList, categoriesList, modalClose }) => {
  const [selectedCategory, setselectedCategory] = useState({ id: null, name: "", });
  const [filteredList, setFilteredList] = useState({ ...categoriesList });

  const [Loading, setLoading] = useState({ status: "", message: "", });
  const [downloadUrl, setDownloadUrl] = React.useState("");
  const [downloadStausLog, setDownloadStausLog] = React.useState(null);
  const [allowAttributes, setAllowAttributes] = useState(false)
  const appData = useContext(AppContext);
  const channelKey = appData?.channelKey;

  async function do_download_pdw() {
    setLoading({ status: "Loading", message: "Downloading pdw" });
    setDownloadStausLog(null);
    // setDisableButton(true);

    try{
      if(!channelKey) return
      const data = await downloadPDW(selectedCategory.id, channelKey, allowAttributes)
      const res = await checkJobStatus(data?.jobid);

      if (res?.data) {
        setDownloadUrl(res.data);
        setselectedCategory({ id: null, name: null });
        toast.success("Downloaded successfully");
        display_error_message({
          status: "Success",
          message: "Downloaded Successful",
        });
      }
      else throw new Error("Download Failed");
    }
    catch(err){
      toast.error(err.message ?? "Unexpected Error");
      display_error_message({ status: "Error", message: "Download Failed" });
    }
    finally {
      setTimeout(() => {
        setDownloadUrl(undefined);
        modalClose();
      }, 4000)
    }
  }
  
  function display_error_message(data) {
    setLoading(data);
    setTimeout(() => {
      setLoading({ status: null, message: null });
    }, 3000);
  }

  async function handleSearchAttribute(value) {
    if (!Utils.isEmpty(value)) {
      let searchval = value.toString().trim().toLowerCase();
      let filteredData = []
        .concat(
          ...Object.values(categoriesList).map((categoryTypeItems) => {
            return categoryTypeItems.filter((item) => {
              return (
                (item.name != null &&
                  item.name.toLowerCase().includes(searchval)) ||
                (item.description != null &&
                  item.description.toLowerCase().includes(searchval))
              );
            });
          })
        )
        .reduce((acc, category) => {
          (acc[category.cattype] = acc[category.cattype] || []).push(category);
          return acc;
        }, {});
      setFilteredList(filteredData);
    } else {
      setFilteredList(categoriesList);
    }
  }

  return (
    <div>
      <div
        className="mt-0 mb-2 border ms-1 input-group rounded-2"
        style={{ width: "380px" }}
      >
        <input
          type="search"
          className="border-0 shadow-none form-control flex-grow-1 fw-normal"
          placeholder={"Search..."}
          onChange={(e) => handleSearchAttribute(e.target.value)}
          style={{
            width: 120,
            paddingTop: 2,
            paddingBottom: 2,
            placeholderTextColor: "#D8D8DC",
            fontSize: 12,
            fontFamily: "Noto Sans",
          }}
        />
        <div
          className="input-group-append"
          style={{
            width: 30,
            height: 36,
            paddingTop: 2,
            paddingBottom: 2,
          }}
        >
          <button
            className="p-1 btn btn-info-secondary"
            type="button"
            style={{ pointerEvents: "none" }}
          >
            <i className="fa fa-search" style={{ color: "#D8D8DC" }} />
          </button>
        </div>
      </div>
      <div className="row">
        <div className="mx-2">
          {categoryTypeList?.map((categoryType, key) => {
            // chack if category type has any categories present
            if (
              !filteredList[categoryType.id] ||
              filteredList[categoryType.id].length <= 0
            )
              return <></>;

            return (
              <div key={categoryType.id}>
                <div className="py-3">
                  <Label
                    message={categoryType.name}
                    fontSize={0.7}
                    fontWeight="600"
                    color="#6B778C"
                  />
                </div>
                <div className="row">
                  {filteredList[categoryType.id]?.map((item, index) => (
                    <div key={item.id} className="col-sm-3">
                      <div className="form-check" style={{ marginBottom: 10 }}>
                        <label
                          className="form-check-label"
                          style={{
                            fontFamily: "Noto Sans",
                            fontSize: ".75rem",
                            fontWeight: "500",
                          }}
                        >
                          <input
                            style={{ fontSize: 11, color: "rgb(9, 28, 170)" }}
                            type="radio"
                            className="form-check-input with-gap"
                            name="optradio"
                            checked={selectedCategory.id === item.id}
                            value={selectedCategory.id}
                            onClick={(e) =>
                              setselectedCategory({
                                id: item.id,
                                name: item.name,
                              })
                            }
                          />
                          {item.name}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <br />
      <div className="tw-space-x-2 tw-flex tw-items-center tw-bg-gray-200 tw-rounded tw-w-max tw-p-2">
        <input id="add_attributes_pdw" type = "checkbox" onChange={(e) => setAllowAttributes(!!e.target.checked)}></input>
        <label htmlFor="add_attributes_pdw" className="tw-text-gray-600">Add attribute values to the template </label>
      </div>
          <br/>
      <div className="d-flex">
        <div>
          <GMSFillButton
            name="Download as XLS"
            disabled={selectedCategory.id === null}
            onClick={() => do_download_pdw(channelKey)}
          />
        </div>
        &nbsp;&nbsp;&nbsp;
        <button
          type="button"
          className=""
          onClick={modalClose}
          style={{
            fontFamily: "Noto Sans",
            fontSize: "11px",
            fontWeight: 500,
            background: "#ffffff",
            border: "1px solid #091caa",
            borderRadius: "4px",
            cursor: "pointer",
            color: "#091caa",
            padding: "0.4rem 0.85rem",
          }}
        >
          Cancel
        </button>
      </div>
      <div className="mt-3">
        <LoadingSuccessErrorAlert loading={Loading} />
      </div>

      {downloadStausLog !== null && (
        <>
          <div className="p-2 bg-white alert alert-primary small" role="alert">
            &nbsp;&nbsp;
            <span className="fas fa-circle-notch fa-spin" />
            <strong>{downloadStausLog[downloadStausLog.length - 1]}</strong>
          </div>
        </>
      )}

      <iframe
        style={{ display: "none" }}
        src={downloadUrl}
        id="iframe_pdw_download"
        title="pdw_download_create"
      />
    </div>
  );
};
export default PdwDownload;